// extracted by mini-css-extract-plugin
export default {"nav":"Navbar_nav__-XkJM","content":"Navbar_content__6uC4L"};